import React from 'react';
import { Link } from 'react-router-dom';
import './Dashboard.css';
import { ROUTES } from '../../../config/routes';
const Dashboard = () => {
  
  return (
    <div className="contact-wrapper overflow-hidden">
      <div className="container pt-120 position-relative">
        <div className="row">
          <div className="col-lg-8">
            
              <h2 className="mb-4">Dashboard</h2>
              <ul>
                
                <li>
                  <Link to={ROUTES.ALL_EVENTS.path} className="dashboard-link">Afficher les évènements</Link>
                </li>
                
                <li>
                  <Link to={ROUTES.ALL_ARTICLES.path} className="dashboard-link">Afficher les articles</Link>
              </li>
              <li>
                <Link to={ROUTES.ALL_NOTIFICATIONS.path} className="dashboard-link">Afficher les notifications</Link>
              </li>
              <li>
                <Link to={ROUTES.ALL_MESSAGES.path} className="dashboard-link">Afficher les messages</Link>
              </li>
                  
                
              </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
